<script lang="ts">
import SectionNumeroObjet from '@/generated/sections/SectionNumeroObjet.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: SectionNumeroObjet
})

</script>
